import React from 'react';
import { useTheme } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';
import Popover from '@mui/material/Popover';

import Button from '@mui/material/Button';
import { Badge, Divider, Typography } from '@mui/material';
import { COLORS, getAgendaColorOrNull } from 'commons/helpers/agendaTheme';
import HintText from 'components/labels/HintText';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const useStyles = makeStyles()(() => ({
  root: { margin: '1rem' },
  button: { margin: '10px 0', width: '100%' },
  colorListContainer: { marginTop: '15px', marginbottom: '20px' },
  colorList: {
    display: 'flex',
    flexDirection: 'row',
    maxWidth: '255px',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'center',
    rowGap: '5px',
    columnGap: '3px',
  },
  avatar: {
    width: '40px',
    height: '40px',
  },
  colorBox: {
    cursor: 'pointer',
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    marginLeft: ' 2px',
    marginRight: ' 2px',
    border: '3px solid white',
  },
}));

// COMPONENT
function ColorPicker({
  label,
  selectedColorId,
  setSelectedColorId,
  showRomoveSelection,
  removeSelectionText,
}) {
  const { classes } = useStyles();
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'color-picker-simple-popover' : undefined;

  const colorSelected = getAgendaColorOrNull(selectedColorId);

  return (
    <div>
      <Badge
        overlap="circular"
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        badgeContent={
          <FontAwesomeIcon
            icon="caret-down"
            color={theme.palette.primary.main}
            style={{ fontSize: 25 }}
            transform={{ rotate: -45 }}
          />
        }
        onClick={handleClick}
      >
        <div>
          <Typography
            variant="subtitle2"
            style={{
              textAlign: 'center',
              fontSize: '13px',
              fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
              fontWeight: '400',
              lineHeight: '1',
              letterSpacing: '-0.05px',
              marginBottom: '4px',
            }}
          >
            Cor
          </Typography>
          <div
            style={{
              borderColor: colorSelected != null ? colorSelected.header : '#d4d4d4',
              backgroundColor: colorSelected != null ? colorSelected.base : 'rgb(241 241 241)',
            }}
            className={classes.colorBox}
          />
        </div>
      </Badge>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <div className={classes.root}>
          {showRomoveSelection && (
            <>
              <Button
                variant="contained"
                className={classes.button}
                color="primary"
                onClick={() => {
                  setSelectedColorId(null);
                  handleClose();
                }}
              >
                {removeSelectionText}
              </Button>
              <Divider />
            </>
          )}

          <div className={classes.colorBoxContainer}>
            <HintText gutterBottom>{label}</HintText>
            <div className={classes.colorList}>
              {COLORS.map((c) => {
                const isSelected = String(selectedColorId) === String(c.id);
                return (
                  <div
                    key={c.id}
                    onClick={() => {
                      setSelectedColorId(c.id);
                      handleClose();
                    }}
                    className={classes.colorBox}
                    style={{
                      backgroundColor: c.base,
                      borderColor: isSelected ? '#7d7d7d' : c.header,
                    }}
                  />
                );
              })}
            </div>
          </div>
        </div>
      </Popover>
    </div>
  );
}

ColorPicker.defaultProps = {
  removeSelectionText: 'Remover seleção',
  label: 'Selecione',
  showRomoveSelection: false,
};
export default ColorPicker;
